// Fontes OFL do nosso pacote: Nunito (sans arredondada) e Instrument Serif (serifada itálica grande).
import "@fontsource/nunito/latin-300.css";
import "@fontsource/nunito/latin-400.css";
import "@fontsource/nunito/latin-600.css";
import "@fontsource/nunito/latin-700.css";
import "@fontsource/instrument-serif/latin-400.css";
import "@fontsource/instrument-serif/latin-400-italic.css";
import "./styles/app.css";
import { effect } from "@preact/signals";
import { render } from "preact";
import { App } from "./ui/App.tsx";
import { hasDraft } from "./ui/Grid.tsx";
import { theme, toast } from "./ui/state.ts";
import { watchUpdates } from "./update.ts";

render(<App />, document.getElementById("app")!);

// Barra de status (iOS instalado) e barra do Chrome no Android seguem o tema escolhido no menu, não só o do aparelho.
const BG = { light: "#F5EDDC", dark: "#202B21" };
effect(() => {
  const t = theme.value;
  for (const m of document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]')) {
    m.content = BG[t === "system" ? (m.media.includes("dark") ? "dark" : "light") : t];
  }
});

// Service worker só no build de produção (em dev o Vite serve módulos soltos). O app instalado no iPhone volta da
// suspensão sem navegar: a cada volta ao primeiro plano procura versão nova.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  const sw = navigator.serviceWorker;
  sw.register("/sw.js").then((reg) => {
    const offer = (apply: () => void) =>
      toast(
        {
          key: "update",
          text: "Nova versão do fai.g pronta.",
          action: {
            label: "Atualizar",
            run: () => {
              (document.activeElement as HTMLElement | null)?.blur?.(); // editores gravam no blur
              // O rascunho da nota rápida só existe na memória: recarregar agora o perderia.
              if (!hasDraft()) return apply();
              toast({ key: "update-wait", text: "Guarde ou apague a nota rápida antes de atualizar." });
              setTimeout(() => offer(apply));
            },
          },
        },
        2_000_000_000, // fica até a pessoa decidir
      );
    const check = watchUpdates(reg, sw, { offer, reload: () => location.reload() });
    document.addEventListener("visibilitychange", () => void (document.visibilityState === "visible" && reg.update().then(check, () => {})));
  }, () => {});
}
